<template>
  <refonte-modal
    v-bind:show="props.show"
    v-on:close="props.on_close"
    v-bind:title="props.title"
    class="popup-large">
    <template v-slot:modalBody>
      <div class="message">
        <span>
          Pour mieux communiquer avec vous et respecter vos choix, nous vous
          invitons à mettre à jour vos préférences.
        </span>
      </div>

      <div class="options">
        <label>
          <input
            type="checkbox"
            v-model="dontShowAgain" />
          Ne plus afficher ce message
        </label>
      </div>
    </template>

    <template v-slot:modalFooter>
      <div class="flex gap-2">
        <template v-if="!dontShowAgain">
          <refonte-button
            v-if="!dontShowAgain"
            variant="secondary"
            v-on:click="props.on_close">
            Plus tard
          </refonte-button>
        </template>
        <template v-else>
          <refonte-button
            v-if="dontShowAgain"
            v-on:click="hidePopup"
            variant="secondary">
            Enregistrer
          </refonte-button>
        </template>

        <refonte-button v-on:click="openPreferences">
          Gérer mes préférences
        </refonte-button>
      </div>
    </template>
  </refonte-modal>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';
  import { router } from '@/router';
  import { API } from '@/http-common';

  const props = withDefaults(
    defineProps<{
      show: boolean;
      on_close: Function;
      title: string;
      class?: string;
    }>(),
    {
      class: ''
    }
  );

  const dontShowAgain = ref(false);

  const hidePopup = async () => {
    await API.put(`/participant/preferences/hide-popup`);
    props.on_close();
  };

  const openPreferences = () => {
    const url = router.resolve('/account/preferences').href;
    window.open(url, '_blank');
    props.on_close();
  };
</script>

<style lang="scss" scoped>
  .message {
    font-size: 16px;
    color: #444;
    line-height: 1.5;
    margin-bottom: 1rem;
  }
  ::v-deep(.popup-large.refonte-modal) {
    max-width: 40%;
    width: 40%;
  }
  .options label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    cursor: pointer;
  }
</style>
